import { useQuery } from '@apollo/client';
import * as React from 'react';
import { USER_GROUPS_QUERY } from '../graphql/queries';

export const useUserGroups = (user: any, purchaserData?: any) => {
  const { data: userGroupsData } = useQuery(USER_GROUPS_QUERY, {
    skip: !user || purchaserData,
  });

  const userGroupIds = React.useMemo(() => {
    if(purchaserData){
       return purchaserData?.visibleGroupLinks?.map((link: any) => link.group._id) || []
      }
    return userGroupsData?.currentUser?.visibleGroupLinks?.map((link: any) => link.group._id) || [];
  }, [userGroupsData]);

  return { userGroupIds };
};
